<template>

  <div>

    <el-row :gutter="12">

      <el-col :md="24" :lg="4" align="left">
        <h3><i class="fa fa-plug" />&nbsp;{{utilLabel + ' Report'}}</h3>
      </el-col>

      <el-col :sm="24" :md="12" :lg="16" align="left">

        <el-form inline>
          <select-month v-model="months" show-select-disabled :disabled="true" />
          <select-year v-model="years" show-select-disabled :disabled="true" />
        </el-form>

      </el-col>

      <el-col :sm="24" :md="12" :lg="4" align="right">
      <download-button
        url="/export/utility"
        icon="fa fa-file-excel"
        type="primary">Excel</download-button>
      </el-col>

    </el-row>


    <data-table
    ref="utiltable"
    table-ref="utiltable"
    url="/report/utility/details/"
    :fields="fields"
    :show-refresh="false"
    sort-field="sorting|DESC,siteName|ASC,sharerNo|ASC"
    :show-search="false">
  </data-table>

  </div>

</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import DownloadButton from '@/components/atoms/files/DownloadButton'


export default {
  mixins: [DateMixins, NumberMixins],

  components: {
    DownloadButton
  },
  methods: {
    formatCabin (value) {
      if (value && value === 1) {
        return '<i class="fa fa-home text-muted"></i>'
      } else {
        return null
      }
    },
    formatMeter (value) {
      if (value || value === 1) {
        return '<i class="fa fa-plug text-primary"></i>'
      } else {
        return null
      }
    }
  },

  data () {
    return {
      years: null,
      months: null,
      sortOrder: [
        {
          field: 'sorting',
          direction: 'desc'
        },
        {
          field: 'siteName',
          direction: 'asc'
        },
        {
          field: 'sharerNo',
          direction: 'desc'
        }
      ],
      thisYear: this.year(),
      utilLabel: this.getUtilLabel(this.siteData),
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: 'year',
          title: 'Yr',
          sortField: 'year',
          titleClass: 'hidden-sm-and-up',
          dataClass: 'hidden-sm-and-up'
        },
        {
          name: 'month',
          title: 'M',
          sortField: 'month',
          titleClass: 'hidden-sm-and-up',
          dataClass: 'hidden-sm-and-up'
        },
        {
          name: 'period',
          title: 'Date',
//          sortField: 'period',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'siteName',
          title: 'Site Name'
//          sortField: 'siteName'
        },
        {
          name: 'sharers',
          title: 'Sharers',
          callback: this.formatInteger,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'total',
          title: 'Total',
          callback: this.formatNumber,
          dataClass: 'text-bold'
        },
        {
          name: 'sharerNo',
          title: '#',
//          sortField: 'sharerNo',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'shortName',
          title: 'Telco',
          dataClass: 'text-muted'
        },
        {
          name: 'telcoSiteId',
          title: 'Telco Site Id',
          titleClass: 'hidden-md-and-down',
          dataClass: 'text-muted hidden-md-and-down'
        },
        {
          name: 'cabin',
          title: 'Cabin',
          callback: this.formatCabin,
          titleClass: 'hidden-md-and-down',
          dataClass: 'text-muted hidden-md-and-down'
        },
        {
          name: 'ownMeter',
          title: 'Own Meter',
          callback: this.formatMeter,
          titleClass: 'hidden-md-and-down',
          dataClass: 'text-muted text-bold hidden-md-and-down'
        },
        {
          name: 'ratio',
          title: 'Ratio %',
          callback: this.formatPercent,
          dataClass: 'text-warning'
        },
        {
          name: 'sharing',
          title: 'Sharing',
          callback: this.formatNumber,
          dataClass: 'text-primary pull-right'
        }
      ]
    }
  }
}

</script>



// WEBPACK FOOTER //
// UtilityReport.vue?f6b0d48e